const newtab = {
  target: '_blank',
  rel: 'noopener',
}

export default newtab
